import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timezoneDate',
  standalone: true  // 👈 This makes it importable directly in components
})
export class TimezoneDatePipe implements PipeTransform {
  transform(
    value: string | Date | null | undefined,
    timeZone: string = 'UTC',
    formatOptions: Intl.DateTimeFormatOptions = {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    }
  ): string {
    if (!value) return '';
    const date = new Date(value);

    let timezone = '';
    switch (timeZone) {
        case 'cst':
            timezone = 'America/Chicago';
        break;
        case 'est':
            timezone = 'America/New_York';
        break;
        case 'mdt':
            timezone = 'America/Denver';
        break;
        case 'pst':
            timezone = "America/Los_Angeles";
        break;

        default:
            timezone = timeZone;
        break;
    }

    return new Intl.DateTimeFormat('en-US', {
      ...formatOptions,
      timeZone: timezone,
    }).format(date);
  }
}
